/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate harmonious colour palettes from a base colour.`)
};

const es_cp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de interés compuesto. Observa cómo crece un depósito único en el tiempo con una tasa y frecuencia de capitalización determinada. Se ejecuta en tu navegador.`)
};

const de_cp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Zinseszinsrechner. Sehen Sie, wie eine Einmaleinzahlung im Laufe der Zeit bei einem bestimmten Zinssatz und einer bestimmten Zinseszinsperiode wächst. Läuft direkt in Ihrem Browser.`)
};

const nl_cp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis calculator voor samengestelde rente. Bekijk hoe een eenmalige inleg in de loop van de tijd groeit tegen een bepaald rentepercentage en renteverrekening. Draait in uw browser.`)
};

const fr_cp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice d'intérêt composé gratuite. Voyez comment un dépôt forfaitaire croît au fil du temps à un taux donné et une fréquence de composition. S'exécute dans votre navigateur.`)
};

const it_cp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito dell'interesse composto. Vedi come un deposito in un'unica soluzione cresce nel tempo a un determinato tasso e frequenza di capitalizzazione. Funziona nel tuo browser.`)
};

const pt_br2_cp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de juros compostos. Veja como um depósito único cresce ao longo do tempo a uma taxa e frequência de capitalização determinadas. Executa no seu navegador.`)
};

const pt_cp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de juros compostos. Veja como um depósito único cresce ao longo do tempo com uma taxa e frequência de capitalização determinadas. Funciona no seu navegador.`)
};

const ja_cp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の複利計算ツール。一度の預金がどのように成長するか、指定された利率と複利計算期間で確認できます。ブラウザ内で実行されます。`)
};

const zh_cp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费复利计算器。查看一笔整存款项在给定利率和复利周期下随时间增长的情况。在您的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_tool_description", locale)
	if (locale === "en") return en_cp_tool_description(inputs)
	if (locale === "es") return es_cp_tool_description(inputs)
	if (locale === "de") return de_cp_tool_description(inputs)
	if (locale === "nl") return nl_cp_tool_description(inputs)
	if (locale === "fr") return fr_cp_tool_description(inputs)
	if (locale === "it") return it_cp_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_cp_tool_description(inputs)
	if (locale === "pt") return pt_cp_tool_description(inputs)
	if (locale === "ja") return ja_cp_tool_description(inputs)
	return zh_cp_tool_description(inputs)
};